import moment from 'moment'
import ServerDateTime from '../models/server-date-time'

/**
 * Extend Number object with method to convert numeric degrees to radians
 */
if (Number.prototype.toRadians === undefined) {
  Number.prototype.toRadians = function () { return this * Math.PI / 180 }
}

export const intervalStartTime = moment({ hour: 0, minute: 0, second: 0, millisecond: 0 })
export const intervalEndTime = moment({ hour: 7, minute: 0, second: 0, millisecond: 0 })

export const TimeStatus = Object.freeze({
  Before: 1,
  Between: 2,
  After: 3
})

export const possibleCashPayments = []
export const denominationsDefault = [0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50]
export const denominationsCH = [1, 2, 5, 10, 20, 50, 100]
export const denominationsVN = [1000, 2000, 5000, 20000, 50000, 100000, 200000, 500000]

/**
 * This is the old Number.prototype.toMoney method
 * @param number
 * @param decimals
 * @param decimal_sep
 * @param thousands_sep
 * @return {string}
 */
export function toMoneyOld (number, decimals, decimal_sep, thousands_sep) {
  var n = number,
    c = isNaN(decimals) ? 2 : Math.abs(decimals),
    d = decimal_sep || '.',
    t = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
    sign = (n < 0) ? '-' : '',
    i = parseInt(n = Math.abs(n).toFixed(c)) + '',
    j = ((j = i.length) > 3) ? j % 3 : 0;
  return sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : '');
}

export function formatPrice (price, currency) {
  const formatted = toMoneyOld(price, currency.nrofdecimals, currency.decimalsepparator, currency.thousandsepparator)

  if (typeof currency.symbolposition !== 'undefined' && currency.symbolposition === 'end') {
    return formatted + ' ' + currency.symbol
  } else {
    return currency.symbol + (currency.symbol !== '' ? ' ' : '') + formatted
  }
}

// A gem by Ka Wing
// TODO remove this by using ES6 template literals
// Initializes a new instance of the StringBuilder class
// and appends the given value if supplied
export class StringBuilder {
  constructor (value) {
    this.string = ''
    this.append(value)
  }

  // Appends the given value to the end of this instance.
  append (value) {
    if (value) {
      this.string += value
    }
    return this
  }

  // Clears the string buffer
  clear () {
    this.string = ''
    return this
  }

  // Returns the string
  toString () {
    return this.string
  }
}

/**
 * A hack to avoid floating points.
 * @param {float} value The number that needs to be checked on.
 * @param {float} decimals The length after the comma/point.
 * @return {float} The number rounded on the given decimals.
 */
export function toMoney (value, decimals) {
  let str = value.toString()
  let n = str.lastIndexOf('.')
  if (n !== -1) {
    str = str.substr(n, str.length)
    if ((str).length >= 4 && str[3] === '5') {
      value += 0.001
    }
  }
  return parseFloat(value.toFixed(decimals))
}

/**
 * Get the money denomination by country code.
 * The current country code can be found with window.GeoCountryCode or check site.inc.php.
 * @param {int} countryCode the code of the country.
 * @return {array} denomination according the country code.
 */
export function getDenominations (countryCode) {
  switch (countryCode) {
    case 6: // CH
      return this.denominationsCH
    case 239: // VN
      return this.denominationsVN
    default:
      return this.denominationsDefault
  }
}

/**
 * Get the possible cash payments
 * @param price  The number the needs to be calculated on.
 * @param denominations denominationsDefault, denominationsCH pr denominationsVN
 * @return {Array<float>} Ascending sorted possible cash payments.
 */
export function getPossibleCashPayments (price, denominations) {
  let possibleCashPayments = []
  var denominations2 = denominations
  var currentMoney = 0

  // add exact value first
  possibleCashPayments.push(price)

  for (var i = 0; i < denominations.length; i++) {
    var denomination = denominations[i]
    currentMoney = this.toMoney(Math.ceil(price / denomination) * denomination, 2)
    var part1 = currentMoney
    var filtered = possibleCashPayments.filter(function (cash) {
      return part1 === cash
    })

    if (filtered.length === 0) {
      possibleCashPayments.push(part1)
    }
    part1 = 0

    var lower = this.toMoney(Math.floor(price / denomination) * denomination, 2)
    for (var ii = 0; ii < denominations2.length - 1; ii++) {
      var denomination2 = denominations2[ii]
      if (denomination2 <= denomination) {
        currentMoney = this.toMoney(lower + Math.ceil((price - lower) / denomination2) * denomination2, 2)
        var part2 = currentMoney
        var filtered2 = possibleCashPayments.filter(function (cash) {
          return part2 === cash
        })

        if (filtered2.length === 0) {
          possibleCashPayments.push(part2)
        }
        part2 = 0
      }
    }
  }
  possibleCashPayments.sort(function (a, b) {
    return a - b
  })
  return possibleCashPayments
}

/**
 * Set the time into the current time.
 * @property {moment} time
 * @property {moment} currentTime
 * @return {moment} the converted time.
 */
export function timeToToday (time, currentTime) {
  return currentTime.clone().set({
    hours: time.hours(),
    minutes: time.minutes(),
    seconds: 0
  })
}

/**
 * Set the date into the current time.
 * @property {moment} date
 * @return {moment} the converted date.
 */
export function getDate (date) {
  return moment({
    year: date.year(),
    month: date.month(),
    date: date.date()
  })
}

/**
 * Pass moment and get seconds back.
 * @param {moment} time
 * @return {long} time in seconds
 */
export function getSeconds (time) {
  var minutes = (time.hours() * 60) + time.minutes()
  return moment.duration(minutes, 'minutes').asSeconds()
}

/**
 * If the time is after midnight and before 07.00, then day will the yesterday.
 * @param {long} timestamp
 * @return {moment}
 */
export function normalizeTime (timestamp) {
  var time = moment(timestamp)
  var hours = time.hours()
  // Between 00:00 and 07:00
  if (hours >= this.intervalStartTime.hours() && hours < this.intervalEndTime.hours()) {
    time.add(-1, 'days')
  }
  return time
}

/**
 * If the time is after midnight and before 07.00, then day will the yesterday.
 * @param {number} timestamp
 * @return {ServerDateTime}
 */
export function normalizeServerTime (timestamp) {
  var time = this.normalizeTime(timestamp)
  return new ServerDateTime(time, time.day())
}

/**
 * Check if the time is between two times.
 * @param {TimeWindow} timeWindow contains the start and end time.
 * @param {moment} compareTime the time that you want to check.
 * @param {moment} serverTime the time that is passed from the server.
 */
export function checkTimeBetween (timeWindow, compareTime, serverTime) {
  // Convert time to sever time.
  var startTime = timeToToday(timeWindow.startTime, serverTime)
  var endTime = timeToToday(timeWindow.endTime, serverTime)

  // Convert time in seconds
  var serverSec = getSeconds(serverTime)
  var startSec = getSeconds(timeWindow.startTime)
  var endSec = getSeconds(timeWindow.endTime)
  var compareSec = getSeconds(compareTime)
  var intervalStartSec = getSeconds(intervalStartTime)
  var intervalEndSec = getSeconds(intervalEndTime)

  // Midnight
  var isMidnight = false
  if (serverSec > intervalStartSec && compareSec < intervalEndSec) {
    isMidnight = true
  }

  // It is not midnight, but maybe the start time is.
  if (!isMidnight && startSec >= intervalStartSec && startSec < intervalEndSec) {
    startTime.add(1, 'days')
  } else if (isMidnight && startSec > intervalStartSec && startSec < intervalEndSec) {
    // it means the server and start time are midnight and don't need to do any fancy stuff.
  } else if (isMidnight) { // it is midnight, but the start time isn't.
    startTime.add(-1, 'days')
  }

  // It is not midnight, but maybe the end time is.
  if (!isMidnight && endSec >= intervalStartSec && endSec < intervalEndSec) {
    endTime.add(1, 'days')
  } else if (isMidnight && endSec > intervalStartSec && endSec < intervalEndSec) {
    // it means the server and end time is midnight and don't need to do any fancy stuff.
  } else if (isMidnight) { // it is midnight, but the end time isn't.{
    endTime.add(-1, 'days')
  }

  if (compareTime.isBefore(startTime)) {
    return TimeStatus.Before
  } else if (compareTime.isBetween(startTime, endTime) || compareTime.isSame(startTime) || compareTime.isSame(endTime)) {
    return TimeStatus.Between
  } else if (compareTime.isAfter(endTime)) {
    return TimeStatus.isAfter
  }
}

/**
 * Calculate distance between two points
 * This uses the ‘haversine’ formula to calculate the great-circle distance between two
 * points – that is, the shortest distance over the earth’s surface – giving an
 * ‘as-the-crow-flies’ distance between the points (ignoring any hills they fly over,
 * of course!).
 */
export function calculateDistance (lat1, lon1, lat2, lon2) {
  var R = 6371e3 // metres
  var φ1 = lat1.toRadians()
  var φ2 = lat2.toRadians()
  var Δφ = (lat2 - lat1).toRadians()
  var Δλ = (lon2 - lon1).toRadians()

  var a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) *
    Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  var d = R * c
  return d
}

const Utils = {
  intervalStartTime: intervalStartTime,
  intervalEndTime: intervalEndTime,
  TimeStatus: TimeStatus,
  possibleCashPayments: possibleCashPayments,
  denominationsDefault: denominationsDefault,
  denominationsCH: denominationsCH,
  denominationsVN: denominationsVN,
  formatPrice: formatPrice,
  StringBuilder: StringBuilder,
  toMoney: toMoney,
  getDenominations: getDenominations,
  getPossibleCashPayments: getPossibleCashPayments,
  timeToToday: timeToToday,
  getDate: getDate,
  getSeconds: getSeconds,
  normalizeTime: normalizeTime,
  normalizeServerTime: normalizeServerTime,
  checkTimeBetween: checkTimeBetween,
  calculateDistance: calculateDistance
}

export default Utils
